import React from "react";

const BackToTop = () => {
    return (
        <a id="mkdf-back-to-top" href="#" className="off"><i className="icofont-rounded-up"></i></a>
    );
};

export default BackToTop;
